/**
 * @param rsvp rsvp object with id and contact information
 * @param injector AngularJS injector instance
 */

export default function askToArchiveRsvp(rsvp, injector) {

    const $translate = injector.get('$translate'),
        alert = injector.get('Alert'),
        translatedValue = (path, params) => {
            return $translate.instant(`store.rsvps.helpers.ask-to-archive-rsvp.${path}`, params);
        };

    return alert.animatedAlert(
        translatedValue('title'),
        translatedValue('content', {rsvp_name: rsvp.contact.data.full_name || rsvp.contact.data.first_name + ' ' + rsvp.contact.data.last_name}),
        'attention',
        {
            confirmButtonText: translatedValue('confirm'),
            cancelButtonText: translatedValue('cancel'),
            wait: true
        }).then(() => {
        return injector.get('$http').delete(`rsvps/${rsvp.id}`).then(() => {
            alert.hide();
            return alert.success('Success', `${rsvp.contact.data.full_name} archived`);
        }, err => alert.handle(err));
    }, err => alert.handle(err));
}



// WEBPACK FOOTER //
// ./src/app/store/rsvps/helpers/ask-to-archive-rsvp.js